import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import {   
    chain,   
    PopulateApiParameter, // the individual handler to replace
} from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
  
const CustomPopulateApiParameter: typeof PopulateApiParameter = props => {    
    // remove properties object
    props.apiParameter = {        
        ...props.parameter,        
        cartLine: {...props.parameter.cartLine, properties: {}},
        cartId: API_URL_CURRENT_FRAGMENT,
    };
};

replaceInChain(chain, PopulateApiParameter, CustomPopulateApiParameter);